jQuery.event.special.touchstart = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchstart", handle, { passive: false });
    } else {
      this.addEventListener("touchstart", handle, { passive: true });
    }
  },
};

jQuery.event.special.touchmove = {
  setup: function (_, ns, handle) {
    if (ns.includes("noPreventDefault")) {
      this.addEventListener("touchmove", handle, { passive: false });
    } else {
      this.addEventListener("touchmove", handle, { passive: true });
    }
  },
};

AOS.init();

var resizedTimes = 0;
function resizeIframe(height, id) {
  var new_height = parseInt(height);
  $("#" + id).css("height", new_height);
}

$(".burger-container").on("click", function () {
  $(".header-nav").addClass("menu-open");
  $("body").addClass("overflow");
});

$(".mobile-close").on("click", function () {
  $(".header-nav").removeClass("menu-open");
  $("body").removeClass("overflow");
  $(".level2-slide").removeClass("open");
});

$("li.level1.sublevels .show-more").on("click", function () {
  $(this).closest("li.level1").children(".level2-slide").toggleClass("open");
});

$(".side-navi-title").on("click", function () {
  $(this).closest(".level2-slide").removeClass("open");
});

$("#newsletter-subscribe-default").on("submit", function () {
  var fbqData = {
    content_category: "Newsletter",
    content_name: $(this).find(".emailInput").val(),
  };
  fbq("track", "Lead", fbqData);
});

$("#newsletter-subscribe-footer").on("submit", function () {
  var fbqData = {
    content_category: "Newsletter",
    content_name: $(this).find(".emailInput").val(),
  };
  fbq("track", "Lead", fbqData);
});

$("#user-menu").on("click", function (event) {
  event.stopPropagation();
  $(".dropdown-menu").toggleClass("open");
});

$(document).on("click", function (event) {
  if (!$(event.target).closest(".dropdown-menu, #user-menu").length) {
    $(".dropdown-menu").removeClass("open");
  }
});

$(".open-search").on("click", function () {
  $(".header-search").fadeToggle(300);
});

$(".landing-video .img").on("click", function () {
  $(this).hide();
  var video = $(".landing-video .video video").get(0);
  $(".landing-video .video").show();
  video.play();
});

/*** SHOP ***/

var productList = {
  loadRequest: null,
  filterTypes: null,
  filters: null,
  load: function (url) {
    $(".products-list-placeholder").prepend(
      '<div class="list-loader"><div class="inner"></div></div>'
    );

    window.history.pushState(null, null, url);

    if (productList.loadRequest != null) {
      productList.loadRequest.abort();
    }

    url = url.split("#")[0] + (url.includes("?") ? "&ajax" : "?ajax");

    productList.loadRequest = $.get(url, function (response) {
      $(".products-list-placeholder").html(response);

      $(".pagination-page").on("click", function () {
        productList.load($(this).attr("href"));
        window.scrollTo(0, 0);
        return false;
      });

      $(".pl-data-url").on("click", function () {
        productList.load($(this).data("url"));
        window.scrollTo(0, 0);
        return false;
      });
    });
  },
  initFilters: function () {
    productList.filterTypes = productList.getFilterTypes();
    productList.filters = productList.getFiltersFromUrl();

    productList.preselectFilters();
    $(".filter input").on("change", function () {
      productList.changeFilter($(this));
    });
  },
  changeFilter: function (filter) {
    var value = encodeURI(filter.val());
    var filterType = filter.closest(".filter-subsection").data("type");

    if (filter.is(":checked")) {
      productList.addFilterToList(filterType, value);
    } else {
      productList.removeFilterFromList(filterType, value);
    }

    productList.writeFiltersToUrl();
  },
  addFilterToList: function (filterType, value) {
    if (productList.filters[filterType] === undefined) {
      productList.filters[filterType] = [];
    }
    productList.filters[filterType].push(value);
  },
  removeFilterFromList: function (filterType, value) {
    if (value == null) {
      delete productList.filters[filterType];
    } else {
      productList.filters[filterType].splice(
        productList.filters[filterType].indexOf(value),
        1
      );
      if (productList.filters[filterType].length == 0) {
        delete productList.filters[filterType];
      }
    }
  },
  writeFiltersToUrl: function () {
    var filtersUrl = [];
    var filterTypes = productList.filterTypes;
    for (var i = 0; i < filterTypes.length; i++) {
      if (productList.filters[filterTypes[i]] !== undefined) {
        filtersUrl.push(
          filterTypes[i] +
            "[" +
            productList.filters[filterTypes[i]].join(",") +
            "]"
        );
      }
    }

    var url = location.href;

    if (url.indexOf("&page=") > -1) {
      var foundPage = location.href.match(/page=(.*?)(?:\&.*)*$/);
      url = url.replace("&page=" + foundPage[1], "");
    } else if (url.indexOf("?page=") > -1) {
      var foundPage = location.href.match(/page=(.*?)(?:\&.*)*$/);
      url = url.replace("?page=" + foundPage[1], "");
    }

    var urlFilters =
      filtersUrl.length > 0 ? "filters=" + filtersUrl.join(";") : "";

    var found = location.href.match(/filters=(.*?)(?:\&.*)*$/);

    if (found) {
      url = url.replace("filters=" + found[1], urlFilters);
    } else if (urlFilters != "") {
      url += (url.indexOf("?") > -1 ? "&" : "?") + urlFilters;
    }
    productList.load(url.endsWith("?") ? url.substr(0, url.length - 1) : url);
  },
  getFiltersFromUrl: function () {
    var filterTypes = productList.filterTypes;
    var filters = {};
    var found = location.href.match(/filters=(.*?)(?:\&.*)*$/);
    if (found != null) {
      var f = found[1].split(";");
      for (var i = 0; i < filterTypes.length; i++) {
        var pattern = new RegExp(filterTypes[i] + "\\[(.*?)\\]");
        var result = pattern.exec(f);
        if (result !== null) {
          filters[filterTypes[i]] = result[1].split(",");
          if (filters[filterTypes[i]] !== undefined) {
            for (var j = 0; j < filters[filterTypes[i]].length; j++) {
              filters[filterTypes[i]][j] = decodeURI(
                filters[filterTypes[i]][j]
              );
            }
          }
        }
      }
    }

    return filters;
  },
  getFilterTypes: function () {
    if (productList.filterTypes === null) {
      productList.filterTypes = [];
      $(".filter-section .filter-subsection").each(function () {
        productList.filterTypes.push($(this).data("type"));
      });
    }
    return productList.filterTypes;
  },
  preselectFilters: function () {
    for (var type in productList.filters) {
      var parent = $('.filter-subsection[data-type="' + type + '"]');

      for (var i = 0; i < productList.filters[type].length; i++) {
        parent
          .find(
            "input[value='" + decodeURI(productList.filters[type][i]) + "']"
          )
          .prop("checked", true);
      }
    }
  },
};

if ($(".products-list-placeholder").length > 0) {
  productList.load(location.href);
}

if ($(".product-filters").length > 0) {
  productList.initFilters();
}
